//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/createStore';
import { lockerSelectedRequest, findLockerAll } from '../../../../../store/modules/parameter/actions';

//HOOKS
import { useCheckoutInfo } from '../../../../../hooks/useCheckoutInfo';

//TYPES
import { Locker } from '../../../../../store/modules/parameter/types';
//COMPONENTS

//STYLES
import {
  Container,
  ContainerAddress,
  ContainerAddressList,
  ContainerAddressRow,
  AddressName,
  AddressAddress,
} from '../styles';
import Loading from '../../../../../components/Loading';

const AddressLockerModal: React.FC = () => {
  const { lockers, loading } = useSelector((state: StoreState) => state.parameter);
  const dispatch = useDispatch();
  const {onSetSelShipping, onSetaddressSelect} = useCheckoutInfo();
 
  useEffect(() => {
    dispatch(findLockerAll());
  }, [dispatch]);

  const handledSelectStore = useCallback(async (locker: Locker) => {
    dispatch(lockerSelectedRequest(locker));
    onSetaddressSelect({id: 1, type:'addressLocker'});
    onSetSelShipping(true);
  }, [dispatch, onSetSelShipping, onSetaddressSelect]);

  if (loading) {
    return (<Loading size={160} bShowText />);
  }
  return (
    <Container>
      <ContainerAddress>
        <ContainerAddressList>
          {lockers && lockers.map(locker => (
              <ContainerAddressRow key={locker.id} onClick={() => handledSelectStore(locker)}>
                <AddressName>
                  <span>{locker.name}</span>
                </AddressName>
                <AddressAddress>{locker.address}, {locker.number} - {locker.neighborhood} - {locker.city} - {locker.state} - CEP: {locker.zip_code}</AddressAddress>
              </ContainerAddressRow>
          ))}
        </ContainerAddressList>
      </ContainerAddress>
    </Container>
  );
}

export default AddressLockerModal;
